import { ReactNode } from 'react';
import classNames from 'classnames';
import { TextButton } from '@praktio/common-ui';
import { Alert as RBAlert } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';

import './Alert.scss';

interface AlertProps {
  icon?: string;
  heading?: string;
  content?: ReactNode;
  variant?: Variant;
  onDismiss?: () => void;
}

// TODO: This will be moved to the Common UI library in the future
const Alert = ({ icon, heading, content, variant = 'primary', onDismiss }: AlertProps) => {
  return (
    <RBAlert
      bsPrefix="Alert"
      className={classNames({
        'Alert--large': !!content,
      })}
      variant={variant}
    >
      <RBAlert.Heading>
        {!!icon && <span className="material-symbols-outlined">{icon}</span>}
        {heading}
      </RBAlert.Heading>

      {content}

      {!!onDismiss && <TextButton onClick={onDismiss}>Dismiss</TextButton>}
    </RBAlert>
  );
};

export default Alert;
